var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import clsx from 'clsx';
import startsWith from 'lodash/startsWith';
import { Route, matchPath, withRouter, } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import Box from '@mui/material/Box';
import api from '../services/api';
import Footer from '../components/Footer';
import MainHeader from '../components/Header';
import { useNurseryContext } from '../contexts/NurseryContext';
import { useSearchContext } from '../contexts/SearchContext';
import SearchBar from '../components/Search/SearchBar';
import { cleanSearch, isPDPPage, resetParam } from '../utils/helpers';
import DetailLayout from '../Routes/DetailLayout';
import { ShopifyCart } from '../components/Shopify';
import shopifyAPI from '../services/shopifyAPI';
import { fetchCart } from '../utils/graphQLMutations';
import ShopifyCartIcon from '../themes/icons/ShopifyCartIcon';
import CustomButton from '../components/CommonComponents/CustomButton';
import { mainLayoutStyles } from '../Routes/LayoutStyles';
var normalizeNavigation = function (navigationInput) {
    var _a;
    if (!navigationInput) {
        return null;
    }
    if (Array.isArray(navigationInput)) {
        return navigationInput;
    }
    return (_a = navigationInput.navigation) !== null && _a !== void 0 ? _a : null;
};
var SharedApp = function (_a) {
    var data = _a.data, history = _a.history, location = _a.location;
    var navigationPayload = data.navigation, commonData = data.commonData, _b = data.apiData, apiData = _b === void 0 ? null : _b;
    var normalizedInitialNavigation = useMemo(function () {
        var normalized = normalizeNavigation(navigationPayload);
        return normalized || [];
    }, [navigationPayload]);
    var _c = useNurseryContext(), setNurseryName = _c.setNurseryName, setNurserySlug = _c.setNurserySlug, isNursery = _c.isNursery, nurseryName = _c.nurseryName, nurserySlug = _c.nurserySlug;
    var _d = useSearchContext(), searchTerm = _d.searchTerm, activeZone = _d.activeZone, origSearchTerm = _d.origSearchTerm, spellingSuggestion = _d.spellingSuggestion, setSearchTerm = _d.setSearchTerm, setOrigSearchTerm = _d.setOrigSearchTerm, setActiveZone = _d.setActiveZone;
    var _e = useState(false), mobNavOpen = _e[0], setMobNavOpen = _e[1];
    var _f = useState(), checkout = _f[0], setCheckout = _f[1];
    var _g = useState(false), cartOpen = _g[0], setCartOpen = _g[1];
    var _h = useState(0), cartCount = _h[0], setCartCount = _h[1];
    var detailNavigation = useMemo(function () {
        if (!apiData || !apiData.nursery_navigation) {
            return null;
        }
        return normalizeNavigation(apiData.nursery_navigation);
    }, [apiData]);
    var routeStartsOnNurseryOrDetail = useMemo(function () {
        if (startsWith(location.pathname, '/nurseries')) {
            return true;
        }
        var plantDetailMatch = matchPath(location.pathname, {
            path: ['/plants/:plantId(\\d+)/:plantName/', '/plants/:plantId(\\d+)/:plantName'],
            exact: true,
        });
        return Boolean(plantDetailMatch);
    }, [location.pathname]);
    var initialNavigationData = useMemo(function () {
        if (routeStartsOnNurseryOrDetail && detailNavigation && detailNavigation.length > 0) {
            return detailNavigation;
        }
        return normalizedInitialNavigation;
    }, [routeStartsOnNurseryOrDetail, detailNavigation, normalizedInitialNavigation]);
    var _j = useState(initialNavigationData), navigationData = _j[0], setNavigationData = _j[1];
    var _k = useState(normalizedInitialNavigation), defaultNavigationData = _k[0], setDefaultNavigationData = _k[1];
    var _l = useState(routeStartsOnNurseryOrDetail && !!detailNavigation && detailNavigation.length > 0), navigationOverrideActive = _l[0], setNavigationOverrideActive = _l[1];
    var notCartPage = !startsWith(location.pathname, '/cart');
    var routeRequiresNurseryNavigation = useCallback(function () {
        if (startsWith(location.pathname, '/nurseries')) {
            return true;
        }
        var plantDetailMatch = matchPath(location.pathname, {
            path: ['/plants/:plantId(\\d+)/:plantName/', '/plants/:plantId(\\d+)/:plantName'],
            exact: true,
        });
        return Boolean(plantDetailMatch);
    }, [location.pathname]);
    var restoreMainNavigation = useCallback(function () {
        if (defaultNavigationData && defaultNavigationData.length > 0) {
            setNavigationData(defaultNavigationData);
        }
        setNavigationOverrideActive(false);
    }, [defaultNavigationData]);
    var applyNavigationOverride = useCallback(function (nav) {
        setNavigationData(nav);
        setNavigationOverrideActive(true);
    }, []);
    var handleSetNavigationData = useCallback(function (navData) {
        var normalizedNavigation = normalizeNavigation(navData);
        if (!normalizedNavigation || normalizedNavigation.length === 0) {
            restoreMainNavigation();
            return;
        }
        applyNavigationOverride(normalizedNavigation);
    }, [applyNavigationOverride, restoreMainNavigation]);
    useEffect(function () {
        if (navigationOverrideActive && !routeRequiresNurseryNavigation()) {
            restoreMainNavigation();
        }
    }, [location.pathname, location.search, navigationOverrideActive, restoreMainNavigation, routeRequiresNurseryNavigation]);
    useEffect(function () {
        if (normalizedInitialNavigation.length === 0) {
            return;
        }
        setDefaultNavigationData(normalizedInitialNavigation);
        if (!navigationOverrideActive) {
            setNavigationData(normalizedInitialNavigation);
        }
    }, [normalizedInitialNavigation, navigationOverrideActive]);
    useEffect(function () {
        if (!routeRequiresNurseryNavigation()) {
            return;
        }
        if (detailNavigation && detailNavigation.length > 0) {
            applyNavigationOverride(detailNavigation);
        }
    }, [routeRequiresNurseryNavigation, detailNavigation, applyNavigationOverride]);
    var changeQuantity = function (plant, modifyNursery, includeShipping, zipCode, province) { return __awaiter(void 0, void 0, void 0, function () {
        var newPlant, newNurseries;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newPlant = {
                        set_quantity: plant.quantity,
                        plant_id: plant.plant_id,
                        variant_id: plant.variant_id,
                    };
                    newNurseries = checkout.nurseries.map(function (nursery) {
                        var item = nursery;
                        if (item.name === modifyNursery.name) {
                            item.shippingLoading = true;
                        }
                        return item;
                    });
                    setCheckout(__assign(__assign({}, checkout), { nurseries: newNurseries }));
                    return [4 /*yield*/, api.checkout.addItems(newPlant).then(function (cart) { return __awaiter(void 0, void 0, void 0, function () {
                            var qty, newCheckCart;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        qty = 0;
                                        cart.cart.nurseries.forEach(function (nursery) {
                                            nursery.items.forEach(function (item) {
                                                qty += item.quantity;
                                            });
                                        });
                                        if (!!includeShipping) return [3 /*break*/, 1];
                                        newCheckCart = cart.cart;
                                        newCheckCart.nurseries = cart.cart.nurseries
                                            .map(function (nursery) {
                                            var newNursery = nursery;
                                            newNursery.checked = true;
                                            newNursery.shippingLoading = false;
                                            return newNursery;
                                        });
                                        setCheckout(newCheckCart);
                                        setCartCount(qty);
                                        return [3 /*break*/, 3];
                                    case 1: return [4 /*yield*/, api.checkout.getCartList("?include_shipping=true&zip=".concat(zipCode, "&province=").concat(province)).then(function (cartList) {
                                            var shippedCheckCart = cartList.cart;
                                            shippedCheckCart.nurseries = cartList.cart.nurseries
                                                .map(function (nursery) {
                                                var newNursery = nursery;
                                                newNursery.checked = true;
                                                newNursery.shippingLoading = false;
                                                return newNursery;
                                            });
                                            setCheckout(shippedCheckCart);
                                            setCartCount(qty);
                                        })
                                            .catch(function (error) {
                                            if (error.TypeError !== 'Failed to fetch')
                                                Sentry.captureException(error);
                                        })];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (error) {
                            if (error.TypeError !== 'Failed to fetch')
                                Sentry.captureException(error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var addToShopifyCart = function (variant, increase_quantity, djangoPk) { return __awaiter(void 0, void 0, void 0, function () {
        var lineItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    lineItems = {
                        plant_id: djangoPk,
                        increase_quantity: increase_quantity,
                        variant_id: variant.id,
                    };
                    return [4 /*yield*/, api.checkout.addItems(lineItems).then(function (cart) {
                            var qty = 0;
                            cart.cart.nurseries.forEach(function (nursery) {
                                nursery.items.forEach(function (item) {
                                    qty += item.quantity;
                                });
                            });
                            var newCheckCart = cart.cart;
                            newCheckCart.nurseries = cart.cart.nurseries.map(function (nursery) {
                                var newNursery = nursery;
                                newNursery.checked = true;
                                return newNursery;
                            });
                            setCartOpen(true);
                            setCheckout(newCheckCart);
                            setCartCount(qty);
                        })
                            .catch(function (error) {
                            if (error.TypeError !== 'Failed to fetch')
                                Sentry.captureException(error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var changeWrapperClass = function () {
        setMobNavOpen(!mobNavOpen);
    };
    var zoneSetHandler = function (zone) {
        var searchString = '';
        var search = cleanSearch(location.search);
        var path = location.pathname;
        if (zone === '0') {
            searchString = resetParam(search, 'zone', false);
        }
        else {
            searchString = resetParam(search, 'zone', zone);
        }
        if (origSearchTerm !== ''
            && spellingSuggestion.spelling_suggestion != null) {
            searchString = searchString.replace(origSearchTerm, spellingSuggestion.spelling_suggestion);
            setOrigSearchTerm('');
        }
        if (typeof window !== 'undefined') {
            if (window.location.href.indexOf('/search/') !== -1
                || window.location.href.indexOf('/featured/') !== -1
                || window.location.href.indexOf('nurseries') !== -1
                || window.location.href.indexOf('/plants/genus/') !== -1
                || window.location.href.indexOf('/plants/tags/') !== -1
                || !isPDPPage()) {
                if (path.length - 1 === path.lastIndexOf('/')) {
                    history.push("".concat(path, "?").concat(searchString));
                }
                else {
                    history.push("".concat(path, "/?").concat(searchString));
                }
                gtag('event', 'page_view');
            }
            else {
                window.location.href = "/search/?".concat(searchString);
            }
        }
    };
    var setQueries = function (query, rawSearch, queryType, slug, url) {
        if (rawSearch === void 0) { rawSearch = ''; }
        if (queryType === void 0) { queryType = ''; }
        if (slug === void 0) { slug = ''; }
        if (url === void 0) { url = ''; }
        localStorage.setItem('scrollPosition', '0');
        var newQuery = query;
        var nextNurseryName = nurseryName;
        var nextNurserySlug = nurserySlug;
        var nextIsNursery = isNursery;
        if (queryType === 'Nursery') {
            setNurseryName(rawSearch);
            nextNurseryName = rawSearch;
            if (slug !== null) {
                setNurserySlug(slug);
                nextNurserySlug = slug;
            }
            nextIsNursery = true;
        }
        gtag('event', 'search', query);
        setSearchTerm(rawSearch);
        var clearedZone = newQuery.indexOf('&zone=null') !== -1;
        if (clearedZone) {
            newQuery = newQuery.replace('&zone=null', '');
            setActiveZone('0');
        }
        var nextActiveZone = clearedZone ? '0' : activeZone;
        if (nextActiveZone !== '0' && newQuery.indexOf('zone') === -1) {
            newQuery = "".concat(newQuery, "&zone=").concat(nextActiveZone);
        }
        if (typeof window !== 'undefined') {
            var originType = 'search';
            if (window.location.pathname.indexOf('/plants/') !== -1) {
                originType = 'plant_detail';
            }
            if (window.location.pathname.indexOf('/nurseries/') !== -1) {
                originType = 'nursery';
            }
            if (window.location.pathname === '/') {
                originType = 'home';
            }
            if (nextIsNursery) {
                switch (originType) {
                    case 'plant_detail':
                        if (!nextNurserySlug && nextNurseryName) {
                            var derivedSlug = nextNurseryName
                                .toLowerCase()
                                .split(' ')
                                .join('-');
                            setNurserySlug(derivedSlug);
                            nextNurserySlug = derivedSlug;
                        }
                        if (newQuery.indexOf('nurseries=') === -1) {
                            window.location.href = "/nurseries/".concat(nextNurserySlug, "/?").concat(newQuery);
                        }
                        else
                            window.location.href = "/nurseries/".concat(nextNurserySlug);
                        break;
                    case 'nursery':
                        if (!slug) {
                            history.push("".concat(window.location.pathname, "?").concat(newQuery));
                        }
                        else {
                            history.push("/nurseries/".concat(nextNurserySlug));
                        }
                        gtag('event', 'page_view');
                        break;
                    case 'home':
                    case 'search':
                    default:
                        window.location.href = "/nurseries/".concat(nextNurserySlug, "/");
                        break;
                }
            }
            else if (url !== '') {
                window.location.href = url;
            }
            else if (window.location.href.indexOf('/search/') !== -1) {
                var newSearch = window.location.search.replace('?', '');
                if (newSearch === newQuery) {
                    return;
                }
                history.push("/search/?".concat(newQuery), { getAPIData: true });
                gtag('event', 'page_view');
            }
            else {
                window.location.href = "/search/?".concat(newQuery);
            }
        }
        localStorage.removeItem('scrollPosition');
    };
    var setCartData = function (cart) { return __awaiter(void 0, void 0, void 0, function () {
        var qty, newCheckCart;
        return __generator(this, function (_a) {
            qty = 0;
            cart.cart.nurseries.forEach(function (nursery) {
                nursery.items.forEach(function (item) {
                    qty += item.quantity;
                });
            });
            newCheckCart = cart.cart;
            newCheckCart.nurseries = cart.cart.nurseries
                .map(function (nursery) {
                var newNursery = nursery;
                newNursery.checked = true;
                newNursery.shippingLoading = true;
                return newNursery;
            });
            setCheckout(newCheckCart);
            setCartCount(qty);
            return [2 /*return*/];
        });
    }); };
    var handleCart = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cartId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    cartId = localStorage.getItem('shopifyCartId');
                    if (!cartId) return [3 /*break*/, 2];
                    return [4 /*yield*/, shopifyAPI.request(fetchCart, { variables: { shopifyCartId: cartId } }).then(function (_a) {
                            var cartData = _a.data;
                            return __awaiter(void 0, void 0, void 0, function () {
                                return __generator(this, function (_b) {
                                    // If we have a cart id but it no longer exists then it means that the user has made the purchase
                                    // so we clear our local cart cookies
                                    if (cartData.node === null) {
                                        api.checkout.clearCart().then(function () {
                                            localStorage.removeItem('shopifyCartId');
                                            api.checkout.getCartList()
                                                .then(function (resp) {
                                                setCartData(resp);
                                            })
                                                .catch(function (error) {
                                                if (error.TypeError !== 'Failed to fetch')
                                                    Sentry.captureException(error);
                                            });
                                        });
                                    }
                                    return [2 /*return*/];
                                });
                            });
                        })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    api.checkout.getCartList()
                        .then(function (resp) {
                        setCartData(resp);
                    })
                        .catch(function (error) {
                        if (error.TypeError !== 'Failed to fetch')
                            Sentry.captureException(error);
                    });
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var closeCart = function () {
        setCartOpen(false);
    };
    useEffect(function () {
        // Handle Cart functionality
        (handleCart)();
    }, []);
    return (React.createElement("div", { className: clsx('wrap', mobNavOpen && 'mobNavOpen') },
        React.createElement(MainHeader, { activePromo: commonData.promo_link, openCartOnClick: function () { return setCartOpen(true); }, navigation: navigationData, changeWrapperClass: changeWrapperClass, showNurseryHeader: false, cartCount: cartCount }),
        notCartPage && (React.createElement(Box, { sx: [mainLayoutStyles.fullWidthContent, { marginTop: '58px' }] },
            React.createElement("div", { className: "fullwidth_search" },
                React.createElement("div", { className: "search_bar" },
                    React.createElement(Box, { sx: mainLayoutStyles.searchBarContainer },
                        React.createElement(SearchBar, { history: history, searchTerm: searchTerm, setQueries: setQueries, zones: commonData.zones, zoneSetHandler: zoneSetHandler, activeZone: activeZone, showNurseryHeader: function () { return false; }, nursery: nurseryName })))))),
        React.createElement(Route, { path: "/plants/:plantId(\\d+)/:plantName/", render: function (props) { return (React.createElement(DetailLayout, __assign({ addToShopifyCart: addToShopifyCart, plantApiData: apiData, setNavigationData: handleSetNavigationData }, props))); } }),
        React.createElement(Footer, null),
        checkout && (React.createElement(React.Fragment, null,
            React.createElement(ShopifyCart, { checkout: checkout, changeQuantity: changeQuantity, count: cartCount, openCart: cartOpen, closeCart: closeCart }),
            React.createElement(CustomButton, { onClick: function () { return setCartOpen(true); }, buttonText: cartCount, buttonClassSX: mainLayoutStyles.toggleButton, endIcon: React.createElement(ShopifyCartIcon, null) })))));
};
export default withRouter(SharedApp);
